/* Brainy Bounce · toy advent calendar.
   One shared WebGL renderer draws every compartment with scissor clipping, so toys, sparkles and
   shadows can never leave their own square. Only animating cells are redrawn.
   Toys are simplified 3D models of example holiday squishies (not exact replicas). */
(function () {
  'use strict';
  var PI = Math.PI;
  function clamp(x, a, b) { return x < a ? a : x > b ? b : x; }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function damp(p, f, k) { return Math.sin(p * PI * 2 * f) * Math.exp(-k * p); }   // decaying wiggle

  function boot(cal) {
    if (cal.__bb) return; cal.__bb = true;
    var grid = cal.querySelector('.bb-cal__grid');
    var cells = Array.prototype.slice.call(cal.querySelectorAll('.bb-cal__cell'));
    var still = function () { return document.documentElement.classList.contains('bb-still') || window.matchMedia('(prefers-reduced-motion: reduce)').matches; };

    // selection highlight + tap (works even without 3D)
    var selected = null;
    cells.forEach(function (c, i) {
      c.addEventListener('click', function () {
        if (selected && selected !== c) selected.setAttribute('aria-pressed', 'false');
        selected = c; c.setAttribute('aria-pressed', 'true');
        if (!c.classList.contains('is-open')) { openDoor(c, i, true); return; }
        if (api) api.play(i);
      });
      c.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && api) api.hover(i, true); });
      c.addEventListener('pointerleave', function () { if (api) api.hover(i, false); });
    });

    function openDoor(c, i, playIt) {
      if (c.classList.contains('is-open')) return;
      c.classList.add('is-open');
      c.setAttribute('aria-label', 'Day ' + (i + 1) + ': ' + c.getAttribute('data-label') + '. Press to play.');
      if (api) { api.redraw(i); if (playIt) setTimeout(function () { api.play(i); }, still() ? 0 : 320); }
      else { c.classList.add('is-pending'); startLoad(); }
    }
    var openAll = cal.querySelector('[data-cal-openall]');
    if (openAll) openAll.addEventListener('click', function () {
      cells.forEach(function (c, i) { setTimeout(function () { openDoor(c, i, false); }, still() ? 0 : i * 90); });
      openAll.hidden = true;
    });
    var api = null;
    var probe = document.createElement('canvas');
    if (!(probe.getContext('webgl') || probe.getContext('experimental-webgl'))) return;   // static fallback stays
    function go() {
      if (api) return;
      try { api = build(cal, grid, cells, still); api.revealOpened(); }
      catch (err) { cal.classList.add('is-static'); cells.forEach(function (c) { c.classList.remove('is-pending'); }); if (window.console) console.warn('Calendar 3D disabled:', err); }
    }
    var loading = false;
    function startLoad() {
      if (loading) return; loading = true;
      if (window.THREE) { go(); return; }
      // reuse the 3D library if the page already requested it (e.g. the homepage hero), never load it twice
      var existing = document.querySelector('script[src*="bb-three"]');
      if (existing) { var wait = setInterval(function () { if (window.THREE) { clearInterval(wait); go(); } }, 60); return; }
      var s = document.createElement('script'); s.src = cal.getAttribute('data-three'); s.onload = go; document.head.appendChild(s);
    }
    // load the renderer only when the calendar is near the screen
    // preload well before the calendar reaches the screen
    var io = new IntersectionObserver(function (en) { if (!en[0].isIntersecting) return; io.disconnect(); startLoad(); }, { rootMargin: '900px 0px' });
    io.observe(cal);
  }

  function build(cal, grid, cells, still) {
    var T = window.THREE;
    var canvas = document.createElement('canvas'); canvas.className = 'bb-cal__canvas'; canvas.setAttribute('aria-hidden', 'true');
    grid.insertBefore(canvas, grid.firstChild);
    var renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'low-power', preserveDrawingBuffer: true });   // keep still toys on screen: only moving cells are redrawn each frame
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, mobile ? 1.5 : 2));
    renderer.outputEncoding = T.sRGBEncoding; renderer.toneMapping = T.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.05;
    renderer.autoClear = false; renderer.setScissorTest(true);
    var scene = new T.Scene();
    var cam = new T.PerspectiveCamera(30, 1, 0.1, 30); cam.position.set(0, 0.9, 4.7); cam.lookAt(0, 0.1, 0);

    // soft studio light + gentle reflections (shared by every cell)
    (function () {
      var es = new T.Scene(), g = new T.SphereGeometry(10, 24, 12), col = [], p = g.attributes.position, c = new T.Color();
      for (var i = 0; i < p.count; i++) { var y = p.getY(i) / 10; c.setRGB(0.35 + 0.6 * Math.max(0, y), 0.25 + 0.5 * Math.max(0, y), 0.4 + 0.5 * Math.max(0, y)); col.push(c.r, c.g, c.b); }
      g.setAttribute('color', new T.Float32BufferAttribute(col, 3));
      es.add(new T.Mesh(g, new T.MeshBasicMaterial({ vertexColors: true, side: T.BackSide })));
      var pm = new T.PMREMGenerator(renderer); scene.environment = pm.fromScene(es, 0.04).texture; pm.dispose();
    })();
    scene.add(new T.HemisphereLight(0xfff4ff, 0x5a2a40, 0.75));
    var key = new T.DirectionalLight(0xffffff, 1.0); key.position.set(2.5, 5, 4); scene.add(key);

    function lin(hex) { return new T.Color(hex).convertSRGBToLinear(); }
    function soft(hex, o) { var m = new T.MeshPhysicalMaterial({ color: lin(hex), roughness: 0.42, clearcoat: 0.6, clearcoatRoughness: 0.3 }); m.envMapIntensity = 0.35; if (o) for (var k in o) m[k] = o[k]; return m; }
    function sparkleTex(base, dots) {
      var c = document.createElement('canvas'); c.width = c.height = 64; var x = c.getContext('2d');
      x.fillStyle = base; x.fillRect(0, 0, 64, 64);
      for (var i = 0; i < 110; i++) { x.fillStyle = dots[i % dots.length]; x.globalAlpha = 0.6 + Math.random() * 0.4; x.fillRect(Math.random() * 64, Math.random() * 64, 1.4, 1.4); }
      var t = new T.CanvasTexture(c); t.encoding = T.sRGBEncoding; t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(2, 2); return t;
    }
    function mesh(g, m) { return new T.Mesh(g, m); }

    // contact shadow under every toy
    var sc = document.createElement('canvas'); sc.width = sc.height = 64; var sx = sc.getContext('2d');
    var gr = sx.createRadialGradient(32, 32, 0, 32, 32, 32); gr.addColorStop(0, 'rgba(40,6,24,.5)'); gr.addColorStop(1, 'rgba(40,6,24,0)'); sx.fillStyle = gr; sx.fillRect(0, 0, 64, 64);
    var shadow = mesh(new T.PlaneGeometry(2.2, 2.2), new T.MeshBasicMaterial({ map: new T.CanvasTexture(sc), transparent: true, depthWrite: false }));
    shadow.rotation.x = -PI / 2; shadow.position.y = -0.98; scene.add(shadow);

    var dotC = document.createElement('canvas'); dotC.width = dotC.height = 32; var dx = dotC.getContext('2d'); var dg = dx.createRadialGradient(16, 16, 0, 16, 16, 16); dg.addColorStop(0, 'rgba(255,255,255,1)'); dg.addColorStop(0.4, 'rgba(255,255,255,.8)'); dg.addColorStop(1, 'rgba(255,255,255,0)'); dx.fillStyle = dg; dx.fillRect(0, 0, 32, 32);
    var dotTex = new T.CanvasTexture(dotC);
    // sparkles (used by tree and globe), kept inside the cell by the scissor
    var spGeo = new T.BufferGeometry(), spPos = new Float32Array(18 * 3);
    spGeo.setAttribute('position', new T.BufferAttribute(spPos, 3));
    var spMat = new T.PointsMaterial({ color: 0xfff3b0, size: 0.12, map: dotTex, transparent: true, depthWrite: false });
    var sparks = new T.Points(spGeo, spMat); scene.add(sparks);
    var spSeed = []; for (var si = 0; si < 18; si++) spSeed.push([Math.random() * PI * 2, 0.4 + Math.random() * 0.6, Math.random()]);

    // ---------------- toy models (simplified, from the advent references) ----------------
    var F = {}, M = {};
    function group() { var g = new T.Group(); g.userData = {}; return g; }

    F.tree = function () {
      var g = group(), body = group(); g.add(body); body.position.y = -0.95;
      var mat = new T.MeshPhysicalMaterial({ color: lin(0x5fe08a), map: sparkleTex('#1fae4f', ['#ffffff', '#e8fff0', '#b6f23a']), transparent: true, opacity: 0.92, roughness: 0.25, clearcoat: 1 });
      mat.envMapIntensity = 0.4;
      var tiers = [[0.78, 0.7, 0.38], [0.6, 0.62, 0.8], [0.42, 0.52, 1.18]].map(function (d) { var m = mesh(new T.ConeGeometry(d[0], d[1], 24), mat); m.position.y = d[2]; body.add(m); return { m: m, y: d[2] }; });
      var sh = new T.Shape(); for (var i = 0; i < 10; i++) { var r = i % 2 ? 0.1 : 0.22, a = i / 10 * PI * 2 + PI / 2; if (!i) sh.moveTo(Math.cos(a) * r, Math.sin(a) * r); else sh.lineTo(Math.cos(a) * r, Math.sin(a) * r); }
      var sg = new T.ExtrudeGeometry(sh, { depth: 0.07, bevelEnabled: true, bevelThickness: 0.03, bevelSize: 0.02, bevelSegments: 2 }); sg.center();
      var star = mesh(sg, new T.MeshStandardMaterial({ color: lin(0xe9eef6), metalness: 0.7, roughness: 0.2 })); star.position.y = 1.62; body.add(star);
      g.userData = { body: body, tiers: tiers, star: star, top: 0.75 };
      return g;
    };
    F.candy = function () {
      var g = group();
      var ball = mesh(new T.SphereGeometry(0.5, 28, 20), new T.MeshPhysicalMaterial({ color: lin(0xff7cc4), map: sparkleTex('#ff4fa8', ['#ffffff', '#ffd1ec', '#d9b3ff']), transparent: true, opacity: 0.92, roughness: 0.2, clearcoat: 1 }));
      g.add(ball);
      var prof = [[0.08, 0], [0.12, 0.1], [0.24, 0.26], [0.36, 0.4], [0.4, 0.45]].map(function (p) { return new T.Vector2(p[0], p[1]); });
      var endMat = new T.MeshPhysicalMaterial({ color: lin(0xffd6ee), transparent: true, opacity: 0.65, roughness: 0.12, clearcoat: 1, side: T.DoubleSide });
      var ends = [-1, 1].map(function (s) { var e = group(), m = mesh(new T.LatheGeometry(prof, 16), endMat); m.rotation.z = s * -PI / 2; e.add(m); e.position.x = s * 0.46; g.add(e); return e; });
      g.position.y = -0.2;
      g.userData = { ball: ball, ends: ends, baseY: -0.2 };
      return g;
    };
    F.globe = function () {
      var g = group();
      var glass = mesh(new T.SphereGeometry(0.62, 28, 20), new T.MeshPhysicalMaterial({ color: lin(0xcfefff), transparent: true, opacity: 0.42, roughness: 0.05, clearcoat: 1, depthWrite: false }));
      glass.position.y = 0.05; glass.renderOrder = 2; g.add(glass);
      var pp = []; for (var i = 0; i < 70; i++) { var v = new T.Vector3(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize().multiplyScalar(Math.cbrt(Math.random()) * 0.5); pp.push(v.x, v.y, v.z); }
      var pg = new T.BufferGeometry(); pg.setAttribute('position', new T.Float32BufferAttribute(pp, 3));
      var glitter = new T.Points(pg, new T.PointsMaterial({ color: 0xc9a8ff, size: 0.09, map: dotTex, transparent: true, depthWrite: false })); glitter.position.y = 0.05; g.add(glitter);
      var prof = [[0.001, -0.95], [0.5, -0.95], [0.53, -0.9], [0.45, -0.62], [0.36, -0.55], [0.001, -0.55]].map(function (p) { return new T.Vector2(p[0], p[1]); });
      g.add(mesh(new T.LatheGeometry(prof, 28), soft(0x9b6cf2, { roughness: 0.3 })));
      g.userData = { glass: glass, glitter: glitter };
      return g;
    };
    F.character = function () {   // pink figure with pointed hat (as in the reference photo)
      var g = group(), m = soft(0xff5fb0);
      var body = mesh(new T.SphereGeometry(0.46, 24, 18), m); body.scale.set(1, 1.15, 0.95); body.position.y = -0.45; g.add(body);
      var head = mesh(new T.SphereGeometry(0.34, 24, 18), m); head.position.y = 0.12; g.add(head);
      var hat = mesh(new T.ConeGeometry(0.33, 0.62, 22), soft(0xe23d93)); hat.position.y = 0.6; hat.rotation.z = 0.18; g.add(hat);
      var pom = mesh(new T.SphereGeometry(0.08, 12, 10), soft(0xffd0ea)); pom.position.set(-0.1, 0.92, 0); g.add(pom);
      g.userData = { hat: hat };
      return g;
    };
    F.reindeer = function () {
      var g = group(), m = soft(0xffa43a);
      var body = mesh(new T.SphereGeometry(0.42, 22, 16), m); body.scale.set(1.25, 0.9, 0.9); body.position.y = -0.45; g.add(body);
      var head = group(); head.position.set(0.42, 0.05, 0); g.add(head);
      head.add(mesh(new T.SphereGeometry(0.3, 22, 16), m));
      [-1, 1].forEach(function (s) {
        var a = mesh(new T.CylinderGeometry(0.04, 0.05, 0.42, 8), soft(0xc77a1e)); a.position.set(0, 0.36, s * 0.14); a.rotation.x = s * 0.35; head.add(a);
        var t = mesh(new T.CylinderGeometry(0.03, 0.04, 0.2, 8), soft(0xc77a1e)); t.position.set(0.06, 0.48, s * 0.22); t.rotation.set(s * 0.5, 0, -0.7); head.add(t);
      });
      [[-0.3, -0.18], [-0.3, 0.18], [0.25, -0.18], [0.25, 0.18]].forEach(function (p) { var l = mesh(new T.CylinderGeometry(0.08, 0.08, 0.3, 10), m); l.position.set(p[0], -0.82, p[1]); g.add(l); });
      g.rotation.y = -0.5;
      g.userData = { head: head, baseRotY: -0.5 };
      return g;
    };
    F.van = function () {
      var g = group(), pink = soft(0xff4fa8);
      var body = mesh(new T.BoxGeometry(1.25, 0.72, 0.72, 4, 3, 3), pink); body.position.y = -0.38; g.add(body);
      var roof = mesh(new T.SphereGeometry(0.5, 20, 14), pink); roof.scale.set(1.25, 0.45, 0.72); roof.position.y = -0.02; g.add(roof);
      var win = soft(0xffd6ee, { roughness: 0.2 });
      [-1, 1].forEach(function (s) { var w = mesh(new T.BoxGeometry(0.75, 0.22, 0.02), win); w.position.set(0, -0.12, s * 0.37); g.add(w); });
      var wheels = [];
      [[-0.38, -1], [-0.38, 1], [0.38, -1], [0.38, 1]].forEach(function (p) { var w = mesh(new T.CylinderGeometry(0.16, 0.16, 0.1, 16), soft(0xb3125f)); w.rotation.x = PI / 2; w.position.set(p[0], -0.78, p[1] * 0.33); g.add(w); wheels.push(w); });
      g.rotation.y = 0.55;
      g.userData = { wheels: wheels, baseRotY: 0.55 };
      return g;
    };
    F.mushroom = function () {
      var g = group();
      var stem = mesh(new T.CylinderGeometry(0.24, 0.3, 0.6, 18), soft(0xdaf7c8)); stem.position.y = -0.62; g.add(stem);
      var cap = mesh(new T.SphereGeometry(0.62, 26, 16, 0, PI * 2, 0, PI / 2), soft(0x52d05a)); cap.position.y = -0.36; g.add(cap);
      var under = mesh(new T.CircleGeometry(0.62, 26), soft(0xc6f0b4)); under.rotation.x = PI / 2; under.position.y = -0.36; g.add(under);
      g.userData = { cap: cap, under: under, stem: stem };
      return g;
    };
    F.ufo = function () {
      var g = group(), p = soft(0x9b5cf6);
      var disc = mesh(new T.SphereGeometry(0.75, 28, 16), p); disc.scale.set(1, 0.28, 1); g.add(disc);
      var rim = mesh(new T.TorusGeometry(0.72, 0.06, 10, 36), soft(0xc6a6ff)); rim.rotation.x = PI / 2; g.add(rim);
      var dome = mesh(new T.SphereGeometry(0.34, 22, 14, 0, PI * 2, 0, PI / 2), soft(0xd9c8ff, { roughness: 0.15 })); dome.position.y = 0.12; g.add(dome);
      g.position.y = -0.2;
      g.userData = { baseY: -0.2 };
      return g;
    };
    F.burger = function () {
      var g = group();
      var bunMat = soft(0xff9a2e), layers = [];
      var bottom = mesh(new T.CylinderGeometry(0.6, 0.55, 0.22, 26), bunMat); bottom.position.y = -0.82; g.add(bottom); layers.push({ m: bottom, y: -0.82 });
      var patty = mesh(new T.CylinderGeometry(0.64, 0.64, 0.2, 26), soft(0xb5541c)); patty.position.y = -0.62; g.add(patty); layers.push({ m: patty, y: -0.62 });
      var cheese = mesh(new T.BoxGeometry(1.1, 0.06, 1.1), soft(0xffd23f)); cheese.position.y = -0.5; cheese.rotation.y = PI / 4; g.add(cheese); layers.push({ m: cheese, y: -0.5 });
      var top = mesh(new T.SphereGeometry(0.62, 26, 16, 0, PI * 2, 0, PI / 2), bunMat); top.scale.y = 0.75; top.position.y = -0.47; g.add(top); layers.push({ m: top, y: -0.47 });
      g.userData = { layers: layers };
      return g;
    };
    F.duck = function () {
      var g = group(), y = soft(0xffd93a);
      var body = mesh(new T.SphereGeometry(0.5, 24, 18), y); body.scale.set(1.2, 0.85, 0.95); body.position.y = -0.55; g.add(body);
      var head = mesh(new T.SphereGeometry(0.3, 22, 16), y); head.position.set(0.32, -0.02, 0); g.add(head);
      var beak = mesh(new T.SphereGeometry(0.13, 16, 10), soft(0xff8a1f)); beak.scale.set(1.4, 0.5, 0.9); beak.position.set(0.6, -0.06, 0); g.add(beak);
      var tail = mesh(new T.ConeGeometry(0.14, 0.3, 12), y); tail.position.set(-0.6, -0.38, 0); tail.rotation.z = 1.0; g.add(tail);
      g.rotation.y = -0.6;
      g.userData = { baseRotY: -0.6 };
      return g;
    };
    var POSE_EXTRA = {}, DUR_EXTRA = {};
    // ---------- Funky Frights (Halloween) toys: simplified models of the 13 toys on the box ----------
    var dark = new T.MeshStandardMaterial({ color: lin(0x1a0a12), roughness: 0.5 });
    function texCanvas(size, draw) { var c = document.createElement('canvas'); c.width = c.height = size; draw(c.getContext('2d'), size); var t = new T.CanvasTexture(c); t.encoding = T.sRGBEncoding; return t; }
    function tri(w, h) { var s = new T.Shape(); s.moveTo(-w / 2, -h / 2); s.lineTo(w / 2, -h / 2); s.lineTo(0, h / 2); s.closePath(); return new T.ShapeGeometry(s); }
    function face(parent, z, opts) {   // jack-o'-lantern style face on the +z side (only on toys that have one)
      opts = opts || {}; var s = opts.s || 1, y = opts.y || 0;
      [-1, 1].forEach(function (k) { var e = mesh(tri(0.16 * s, 0.14 * s), dark); e.position.set(k * 0.15 * s, y + 0.08 * s, z); parent.add(e); });
      var m = new T.Shape(); m.moveTo(-0.2 * s, 0); m.quadraticCurveTo(0, -0.16 * s, 0.2 * s, 0); m.quadraticCurveTo(0, -0.07 * s, -0.2 * s, 0);
      var mo = mesh(new T.ShapeGeometry(m), dark); mo.position.set(0, y - 0.08 * s, z); parent.add(mo);
    }
    F.pumpkin = function () {
      var g = group(), o = soft(0xff7a1a);
      var pts = []; for (var i = 0; i <= 12; i++) { var a = -PI / 2 + i / 12 * PI * 0.92; pts.push(new T.Vector2(Math.max(0.02, Math.cos(a) * 0.62), Math.sin(a) * 0.5)); }
      var body = mesh(new T.LatheGeometry(pts, 28), o); body.scale.set(1, 1, 0.92); body.position.y = -0.42; g.add(body);
      var rim = mesh(new T.TorusGeometry(0.4, 0.05, 8, 28), o); rim.rotation.x = PI / 2; rim.position.y = 0.04; g.add(rim);
      var handle = mesh(new T.TorusGeometry(0.42, 0.04, 8, 30, PI), o); handle.position.y = 0.04; g.add(handle);
      var fg = group(); fg.position.y = -0.42; g.add(fg); face(fg, 0.58, { s: 1.15 });
      g.userData = { handle: handle, rest: function () { handle.rotation.set(0, 0, 0); } };
      return g;
    };
    F.hand = function () {
      var g = group(), gr = soft(0x2f8a3e), hand = group(); hand.position.y = -0.95; g.add(hand);
      var palm = mesh(new T.BoxGeometry(0.62, 0.62, 0.26, 2, 2, 2), gr); palm.position.y = 0.42; hand.add(palm);
      var cuff = mesh(new T.CylinderGeometry(0.3, 0.34, 0.2, 18), gr); cuff.position.y = 0.06; hand.add(cuff);
      var fingers = [];
      [-0.22, -0.075, 0.075, 0.22].forEach(function (x, i) {
        var f = group(); f.position.set(x, 0.72, 0); hand.add(f);
        var l = [0.42, 0.5, 0.48, 0.38][i]; var seg = mesh(new T.CylinderGeometry(0.065, 0.075, l, 10), gr); seg.position.y = l / 2; f.add(seg);
        var tip = mesh(new T.SphereGeometry(0.068, 10, 8), gr); tip.position.y = l; f.add(tip); fingers.push(f);
      });
      var th = group(); th.position.set(-0.32, 0.38, 0); th.rotation.z = 0.9; hand.add(th);
      var ts = mesh(new T.CylinderGeometry(0.07, 0.08, 0.34, 10), gr); ts.position.y = 0.17; th.add(ts);
      g.userData = { hand: hand, fingers: fingers, rest: function () { hand.rotation.set(0, 0, 0); fingers.forEach(function (f) { f.rotation.set(0, 0, 0); }); } };
      return g;
    };
    F.werewolf = function () {
      var g = group(), red = soft(0xe8432c), head = group(); head.position.y = -0.3; g.add(head);
      var skull = mesh(new T.SphereGeometry(0.58, 24, 18), red); skull.scale.set(1, 0.95, 0.9); head.add(skull);
      [-1, 1].forEach(function (k) { var ear = mesh(new T.ConeGeometry(0.16, 0.34, 10), red); ear.position.set(k * 0.38, 0.5, 0); ear.rotation.z = -k * 0.4; head.add(ear); });
      var snout = mesh(new T.SphereGeometry(0.28, 18, 14), red); snout.scale.set(1.1, 0.75, 0.9); snout.position.set(0, -0.14, 0.42); head.add(snout);
      var jaw = group(); jaw.position.set(0, -0.28, 0.4); head.add(jaw);
      for (var i = 0; i < 4; i++) { var tth = mesh(new T.ConeGeometry(0.04, 0.12, 6), soft(0xfff6e6)); tth.rotation.x = PI; tth.position.set(-0.15 + i * 0.1, 0.0, 0.08); jaw.add(tth); }
      [-1, 1].forEach(function (k) { var e = mesh(new T.SphereGeometry(0.07, 10, 8), dark); e.position.set(k * 0.2, 0.12, 0.5); head.add(e); });
      g.userData = { head: head, jaw: jaw, rest: function () { head.rotation.set(0, 0, 0); jaw.position.y = -0.28; } };
      return g;
    };
    F.tombstone = function () {
      var g = group(), grey = soft(0x9aa0a8, { roughness: 0.75, clearcoat: 0.1 });
      var sh = new T.Shape(); sh.moveTo(-0.5, -0.6); sh.lineTo(0.5, -0.6); sh.lineTo(0.5, 0.2); sh.absarc(0, 0.2, 0.5, 0, PI, false); sh.lineTo(-0.5, -0.6);
      var geo = new T.ExtrudeGeometry(sh, { depth: 0.24, bevelEnabled: true, bevelThickness: 0.06, bevelSize: 0.06, bevelSegments: 3 }); geo.translate(0, 0, -0.12);
      var stone = mesh(geo, grey); stone.position.y = -0.3; g.add(stone);
      var label = texCanvas(128, function (x, s) { x.clearRect(0, 0, s, s); x.fillStyle = '#5c616a'; x.font = 'bold 44px Arial'; x.textAlign = 'center'; x.fillText('RIP', 64, 104); x.beginPath(); x.arc(64, 44, 22, 0, PI * 2); x.fill(); x.fillStyle = '#9aa0a8'; x.fillRect(52, 38, 8, 8); x.fillRect(68, 38, 8, 8); });
      var plate = mesh(new T.PlaneGeometry(0.8, 0.8), new T.MeshBasicMaterial({ map: label, transparent: true })); plate.position.set(0, -0.15, 0.19); g.add(plate);
      g.userData = { rest: function () {} };
      return g;
    };
    F.crystal = function () {
      var g = F.globe(); var u = g.userData;
      u.glass.material = u.glass.material.clone(); u.glass.material.color = lin(0xf0e6ff); u.glass.material.opacity = 0.38;
      u.glitter.material = u.glitter.material.clone(); u.glitter.material.color = lin(0xffd6f4);
      g.userData.rest = function () {};
      return g;
    };
    F.skull = function () {
      var g = group(), y = soft(0xffc93a), head = group(); head.position.y = -0.25; g.add(head);
      var cran = mesh(new T.SphereGeometry(0.55, 24, 18), y); cran.scale.set(0.95, 1, 0.92); head.add(cran);
      var jaw = mesh(new T.BoxGeometry(0.62, 0.28, 0.5, 2, 2, 2), y); jaw.position.set(0, -0.5, 0.08); head.add(jaw);
      [-1, 1].forEach(function (k) { var e = mesh(new T.SphereGeometry(0.13, 14, 10), dark); e.scale.z = 0.4; e.position.set(k * 0.2, 0.0, 0.48); head.add(e); });
      var nose = mesh(tri(0.1, 0.1), dark); nose.rotation.z = PI; nose.position.set(0, -0.16, 0.52); head.add(nose);
      for (var i = 0; i < 4; i++) { var tt = mesh(new T.BoxGeometry(0.1, 0.12, 0.04), soft(0xfff3d0)); tt.position.set(-0.15 + i * 0.1, -0.4, 0.33); jaw.add(tt); tt.position.set(-0.15 + i * 0.1, 0.08, 0.26); }
      g.userData = { head: head, jaw: jaw, rest: function () { head.rotation.set(0, 0, 0); jaw.position.y = -0.5; } };
      return g;
    };
    F.cube = function () {
      var marble = texCanvas(128, function (x, s) { x.fillStyle = '#9b6cf2'; x.fillRect(0, 0, s, s); x.strokeStyle = 'rgba(30,10,60,.85)'; x.lineWidth = 5; for (var i = 0; i < 5; i++) { x.beginPath(); x.moveTo(Math.random() * s, 0); for (var k = 1; k < 6; k++) x.lineTo(Math.random() * s, k * s / 5); x.stroke(); } x.fillStyle = 'rgba(255,255,255,.5)'; for (var j = 0; j < 60; j++) x.fillRect(Math.random() * s, Math.random() * s, 1.5, 1.5); });
      var g = group(), m = new T.MeshPhysicalMaterial({ map: marble, roughness: 0.3, clearcoat: 0.8 }); m.envMapIntensity = 0.35;
      var box = mesh(new T.BoxGeometry(0.95, 0.95, 0.95, 3, 3, 3), m);
      var p = box.geometry.attributes.position, v = new T.Vector3();
      for (var i = 0; i < p.count; i++) { v.fromBufferAttribute(p, i); var n = v.clone().normalize().multiplyScalar(0.66); v.lerp(n, 0.28); p.setXYZ(i, v.x, v.y, v.z); }   // round the edges
      box.geometry.computeVertexNormals(); box.position.y = -0.42; box.rotation.y = 0.5; g.add(box);
      g.userData = { box: box, rest: function () { box.scale.set(1, 1, 1); box.position.y = -0.42; } };
      return g;
    };
    F.eyeball = function () {
      var g = group();
      var ball = mesh(new T.SphereGeometry(0.58, 28, 20), new T.MeshPhysicalMaterial({ color: lin(0xf2f6ff), map: sparkleTex('#e9eef8', ['#b9c6ff', '#ffffff', '#d7b8ff']), roughness: 0.15, clearcoat: 1 }));
      g.add(ball);
      var iris = mesh(new T.CircleGeometry(0.26, 24), soft(0x1f8fe0)); iris.position.z = 0.575; g.add(iris);
      var pupil = mesh(new T.CircleGeometry(0.12, 20), dark); pupil.position.z = 0.58; g.add(pupil);
      var shine = mesh(new T.CircleGeometry(0.05, 12), new T.MeshBasicMaterial({ color: 0xffffff })); shine.position.set(0.08, 0.08, 0.585); g.add(shine);
      g.position.y = -0.3;
      g.userData = { baseY: -0.3, rest: function () {} };
      return g;
    };
    F.redcandy = function () {
      var g = group(), red = soft(0xe8362c);
      var ball = mesh(new T.SphereGeometry(0.42, 24, 18), red); ball.scale.set(1.1, 0.95, 0.9); g.add(ball);
      var prof = [[0.06, 0], [0.1, 0.1], [0.22, 0.25], [0.32, 0.36], [0.34, 0.4]].map(function (p) { return new T.Vector2(p[0], p[1]); });
      var ends = [-1, 1].map(function (s) { var e = group(), m = mesh(new T.LatheGeometry(prof, 14), red); m.material.side = T.DoubleSide; m.rotation.z = s * -PI / 2; e.add(m); e.position.x = s * 0.42; g.add(e); return e; });
      face(g, 0.39, { s: 0.85 });
      g.position.y = -0.25;
      g.userData = { ball: ball, ends: ends, baseY: -0.25, rest: function () { ends[0].rotation.x = 0; ends[1].rotation.x = 0; ball.scale.set(1.1, 0.95, 0.9); } };
      return g;
    };
    F.spider = function () {
      var g = group(), blk = soft(0x1c1622, { roughness: 0.6 }), body = group(); body.position.y = -0.55; g.add(body);
      body.add(mesh(new T.SphereGeometry(0.36, 20, 16), blk));
      var fuzz = new T.InstancedMesh(new T.ConeGeometry(0.02, 0.12, 4), blk, 160), mm = new T.Matrix4(), q = new T.Quaternion(), up = new T.Vector3(0, 1, 0);
      for (var i = 0; i < 160; i++) { var yy = 1 - i / 159 * 2, rr = Math.sqrt(1 - yy * yy), th = i * 2.4; var d = new T.Vector3(Math.cos(th) * rr, yy, Math.sin(th) * rr); q.setFromUnitVectors(up, d); mm.compose(d.clone().multiplyScalar(0.38), q, new T.Vector3(1, 1, 1)); fuzz.setMatrixAt(i, mm); }
      body.add(fuzz);
      var legs = [];
      for (var k = 0; k < 8; k++) {
        var side = k < 4 ? -1 : 1, idx = k % 4, lg = group(); lg.position.set(side * 0.28, -0.05, -0.24 + idx * 0.16); body.add(lg);
        var a = mesh(new T.CylinderGeometry(0.035, 0.035, 0.4, 6), blk); a.position.set(side * 0.18, 0.1, 0); a.rotation.z = side * 1.0; lg.add(a);
        var b = mesh(new T.CylinderGeometry(0.03, 0.02, 0.38, 6), blk); b.position.set(side * 0.4, -0.08, 0); b.rotation.z = -side * 0.5; lg.add(b);
        legs.push(lg);
      }
      [-1, 1].forEach(function (k) { var e = mesh(new T.SphereGeometry(0.06, 10, 8), soft(0xffffff)); e.position.set(k * 0.12, 0.08, 0.34); body.add(e); });
      g.userData = { body: body, legs: legs, rest: function () { body.position.y = -0.55; legs.forEach(function (l) { l.rotation.set(0, 0, 0); }); } };
      return g;
    };
    F.frank = function () {
      var g = group(), gr = soft(0x7fdc4a), head = group(); head.position.y = -0.35; g.add(head);
      var box = mesh(new T.BoxGeometry(0.8, 0.88, 0.72, 3, 3, 3), gr); head.add(box);
      var hair = mesh(new T.BoxGeometry(0.84, 0.16, 0.76), soft(0x2a5a22)); hair.position.y = 0.48; head.add(hair);
      [-1, 1].forEach(function (k) { var bolt = mesh(new T.CylinderGeometry(0.06, 0.06, 0.22, 10), soft(0xb9c0c8, { metalness: 0.5 })); bolt.rotation.z = PI / 2; bolt.position.set(k * 0.48, -0.22, 0); head.add(bolt);
        var e = mesh(new T.BoxGeometry(0.16, 0.06, 0.02), dark); e.position.set(k * 0.17, 0.08, 0.37); head.add(e); });
      var mouth = mesh(new T.BoxGeometry(0.4, 0.05, 0.02), dark); mouth.position.set(0, -0.2, 0.37); head.add(mouth);
      head.rotation.y = 0.25;
      g.userData = { head: head, rest: function () { head.rotation.set(0, 0.25, 0); head.position.y = -0.35; } };
      return g;
    };
    F.candycorn = function () {
      var g = group(), corn = group(); corn.position.y = -0.95; g.add(corn);
      [[0.5, 0.42, 0xffd23f, 0.0], [0.42, 0.5, 0xff8a1f, 0.42], [0.2, 0.42, 0xfff6e6, 0.88]].forEach(function (d, i) {
        var r0 = [0.5, 0.42, 0.2][i], r1 = [0.42, 0.2, 0.03][i];
        var c = mesh(new T.CylinderGeometry(r1, r0, d[1], 24), soft(d[2])); c.position.y = d[3] + d[1] / 2; corn.add(c);
      });
      var tip = mesh(new T.SphereGeometry(0.05, 10, 8), soft(0xfff6e6)); tip.position.y = 1.32; corn.add(tip);
      var fg = group(); fg.position.set(0, 0.62, 0); corn.add(fg); face(fg, 0.36, { s: 0.8 });
      g.userData = { corn: corn, rest: function () { corn.rotation.set(0, 0, 0); corn.scale.set(1, 1, 1); } };
      return g;
    };
    F.greenskull = function () {
      var g = group();
      var tex = texCanvas(128, function (x, s) { x.fillStyle = '#1f4a3a'; x.fillRect(0, 0, s, s); for (var i = 0; i < 300; i++) { x.fillStyle = ['#bfe8d0', '#ffffff', '#5fae86'][i % 3]; x.globalAlpha = 0.5 + Math.random() * 0.5; x.fillRect(Math.random() * s, Math.random() * s, 1.6, 1.6); } x.globalAlpha = 0.9; x.fillStyle = '#c9d6d0'; x.beginPath(); x.arc(64, 58, 22, 0, PI * 2); x.fill(); x.fillRect(52, 72, 24, 14); x.fillStyle = '#1f4a3a'; x.beginPath(); x.arc(56, 56, 6, 0, PI * 2); x.arc(72, 56, 6, 0, PI * 2); x.fill(); });
      var ball = mesh(new T.SphereGeometry(0.58, 28, 20), new T.MeshPhysicalMaterial({ map: tex, roughness: 0.2, clearcoat: 1 }));
      ball.material.envMapIntensity = 0.4; ball.rotation.y = -PI / 2; g.add(ball);
      g.position.y = -0.3;
      g.userData = { ball: ball, baseY: -0.3, rest: function () { ball.scale.set(1, 1, 1); ball.rotation.set(0, -PI / 2, 0); } };
      return g;
    };
    Object.assign(POSE_EXTRA, {
      pumpkin: function (g, p, A) { g.position.y = Math.max(0, Math.sin(clamp(p * 1.8, 0, 1) * PI)) * 0.14 * A; g.userData.handle.rotation.x = damp(p, 2, 2.5) * 0.6 * A; g.rotation.z = damp(p, 1.5, 3) * 0.08 * A; },
      hand: function (g, p, A) { var u = g.userData; u.hand.rotation.z = Math.sin(p * PI * 3) * 0.22 * A * (1 - p); u.fingers.forEach(function (f, i) { f.rotation.x = Math.max(0, Math.sin(clamp(p * 2 - i * 0.08, 0, 1) * PI)) * 0.5 * A; }); },
      werewolf: function (g, p, A) { var u = g.userData; u.head.rotation.y = Math.sin(p * PI * 4) * 0.25 * A * (1 - p); u.jaw.position.y = -0.28 - Math.abs(Math.sin(p * PI * 5)) * 0.05 * A; },
      tombstone: function (g, p, A) { g.rotation.z = damp(p, 1.8, 2.5) * 0.14 * A; g.position.y = Math.max(0, Math.sin(clamp(p * 1.5, 0, 1) * PI)) * 0.08 * A; },
      crystal: function (g, p, A, dt) { return POSE.globe(g, p, A, dt); },
      skull: function (g, p, A) { var u = g.userData; u.jaw.position.y = -0.5 - Math.abs(Math.sin(p * PI * 6)) * 0.06 * A * (1 - p); u.head.rotation.z = damp(p, 2, 3) * 0.12 * A; },
      cube: function (g, p, A) { var u = g.userData, sq = Math.sin(clamp(p * 2.4, 0, 1) * PI) * 0.22 * A + damp(p, 3, 4) * 0.04 * A * (p > 0.42 ? 1 : 0); u.box.scale.set(1 + sq * 0.6, 1 - sq, 1 + sq * 0.6); u.box.position.y = -0.42 - sq * 0.45; },
      eyeball: function (g, p, A) { g.rotation.y = Math.sin(p * PI * 2) * 0.6 * Math.min(A, 1.4); g.rotation.x = Math.sin(p * PI * 4) * 0.15 * A * (1 - p); g.position.y = g.userData.baseY + Math.max(0, Math.sin(clamp(p * 2, 0, 1) * PI)) * 0.06 * A; },
      redcandy: function (g, p, A) { var u = g.userData; g.rotation.z = damp(p, 1.6, 2.6) * 0.28 * A; var tw = Math.sin(clamp(p * 1.6, 0, 1) * PI) * 1.3 * A; u.ends[0].rotation.x = -tw; u.ends[1].rotation.x = tw; },
      spider: function (g, p, A) { var u = g.userData; u.body.position.y = -0.55 + Math.abs(Math.sin(p * PI * 4)) * 0.06 * A; u.legs.forEach(function (l, i) { l.rotation.y = Math.sin(p * PI * 8 + i * 1.3) * 0.25 * A * (1 - p * 0.5); }); g.position.x = Math.sin(p * PI * 2) * 0.12 * A; },
      frank: function (g, p, A) { var u = g.userData; u.head.position.y = -0.35 + Math.max(0, Math.sin(clamp(p * 2, 0, 1) * PI)) * 0.1 * A; u.head.rotation.x = Math.sin(p * PI * 3) * 0.14 * A * (1 - p); },
      candycorn: function (g, p, A) { var u = g.userData, sq = Math.sin(clamp(p * 2.4, 0, 1) * PI) * 0.15 * A; u.corn.scale.set(1 + sq * 0.5, 1 - sq, 1 + sq * 0.5); u.corn.rotation.z = damp(p, 2, 3) * 0.14 * A; },
      greenskull: function (g, p, A) { var u = g.userData, sq = Math.sin(clamp(p * 2.6, 0, 1) * PI) * 0.16 * A; u.ball.scale.set(1 + sq * 0.6, 1 - sq, 1 + sq * 0.6); u.ball.rotation.y = -PI / 2 + Math.sin(p * PI) * 0.8 * A; }
    });
    Object.assign(DUR_EXTRA, { pumpkin: 1.5, hand: 1.6, werewolf: 1.4, tombstone: 1.6, crystal: 2.4, skull: 1.4, cube: 1.4, eyeball: 1.8, redcandy: 1.6, spider: 1.6, frank: 1.4, candycorn: 1.4, greenskull: 1.6 });

    // build only the toy models this calendar uses
    cells.forEach(function (c) { var k = c.getAttribute('data-toy'); if (F[k] && !M[k]) { M[k] = F[k](); M[k].visible = false; scene.add(M[k]); } });

    // ---------------- per-toy animation: absolute pose from progress (never accumulates) ----------------
    function reset(g) {
      g.position.x = 0; g.position.z = 0; g.position.y = g.userData.baseY || 0;
      g.rotation.set(0, g.userData.baseRotY || 0, 0); g.scale.set(1, 1, 1);
    }
    var POSE = {
      tree: function (g, p, A) {   // wiggle, compress, spring upright
        var u = g.userData, squash = Math.sin(clamp(p * 2.2, 0, 1) * PI) * 0.22 * A;
        u.body.rotation.z = damp(p, 2.5, 4) * 0.12 * A;
        u.tiers.forEach(function (t, i) { t.m.scale.set(1 + squash * 0.6, 1 - squash, 1 + squash * 0.6); t.m.position.y = t.y * (1 - squash * 0.9); });
        u.star.position.y = 1.62 * (1 - squash * 0.9); u.star.rotation.z = damp(p, 3, 3) * 0.4 * A;
        return { sparkle: p > 0.35 ? (A > 1.5 ? 1 : 0.5) : 0, sparkleY: 0.7 };
      },
      candy: function (g, p, A) {  // rock, twist, settle
        var u = g.userData;
        g.rotation.z = damp(p, 1.6, 2.6) * 0.3 * A;
        var tw = Math.sin(clamp(p * 1.6, 0, 1) * PI) * 1.4 * A;
        u.ends[0].rotation.x = -tw; u.ends[1].rotation.x = tw;
        var sq = Math.sin(clamp(p * 3, 0, 1) * PI) * 0.12 * (A - 0.4);
        u.ball.scale.set(1 + sq, 1 - sq, 1 + sq * 0.6);
      },
      globe: function (g, p, A, dt) { // tilt + glitter swirl
        var u = g.userData;
        g.rotation.z = damp(p, 1.2, 2.2) * 0.22 * A;
        u.glitter.rotation.y += dt * (2 + 9 * A) * (1 - p);
        u.glitter.rotation.x = Math.sin(p * PI * 2) * 0.3 * A;
        var sq = Math.sin(clamp(p * 3, 0, 1) * PI) * 0.12 * (A - 0.8);
        u.glass.scale.set(1 + sq, 1 - Math.max(0, sq), 1 + sq);
        return { sparkle: 0 };
      },
      character: function (g, p, A) {   // happy hop + little turn
        var hop = Math.max(0, Math.sin(clamp(p * 1.8, 0, 1) * PI)) * 0.15 * A;
        g.position.y = hop;
        var land = p > 0.55 && p < 0.75 ? Math.sin((p - 0.55) / 0.2 * PI) * 0.12 * A : 0;
        g.scale.set(1 + land, 1 - land, 1 + land);
        g.rotation.y = Math.sin(p * PI * 2) * 0.45 * Math.min(A, 1.4);
        g.userData.hat.rotation.z = 0.18 + damp(p, 2, 3) * 0.3 * A;
      },
      reindeer: function (g, p, A) {
        g.position.y = Math.max(0, Math.sin(clamp(p * 2, 0, 1) * PI)) * 0.12 * A;
        g.userData.head.rotation.z = damp(p, 2.2, 3) * 0.35 * A;
        g.rotation.y = g.userData.baseRotY + Math.sin(p * PI * 2) * 0.25 * A;
      },
      van: function (g, p, A) {     // little drive back and forth, wheels spin, body bounces
        var d = Math.sin(p * PI * 2) * 0.22 * A;
        g.position.x = d;
        g.position.y = Math.abs(Math.sin(p * PI * 8)) * 0.04 * A;
        g.userData.wheels.forEach(function (w) { w.rotation.y = d * 6; });
        g.rotation.z = -Math.cos(p * PI * 2) * 0.04 * A;
      },
      mushroom: function (g, p, A) { // squish the cap down, boing back
        var u = g.userData, sq = Math.sin(clamp(p * 2.4, 0, 1) * PI) * 0.25 * A + damp(p, 3, 4) * 0.05 * A * (p > 0.42 ? 1 : 0);
        u.cap.scale.set(1 + sq * 0.6, 1 - sq, 1 + sq * 0.6); u.under.scale.set(1 + sq * 0.6, 1 + sq * 0.6, 1);
        var cy = -0.36 - sq * 0.25; u.cap.position.y = cy; u.under.position.y = cy;
        u.stem.scale.set(1 + sq * 0.3, 1 - sq * 0.4, 1 + sq * 0.3); u.stem.position.y = -0.62 - sq * 0.1;
      },
      ufo: function (g, p, A) {     // hover, spin and wobble
        g.position.y = g.userData.baseY + Math.sin(p * PI * 2) * 0.12 * A;
        g.rotation.y = p * PI * 2 * (A > 1.5 ? 2 : 1);
        g.rotation.z = damp(p, 1.5, 2) * 0.22 * A;
      },
      burger: function (g, p, A) {  // layers squish in sequence
        g.userData.layers.forEach(function (l, i) {
          var q = clamp(p * 2.2 - i * 0.12, 0, 1), sq = Math.sin(q * PI) * 0.22 * A;
          l.m.position.y = -0.82 + (l.y + 0.82) * (1 - sq); l.m.scale.set(1 + sq * 0.4, 1 - sq * 0.5, 1 + sq * 0.4);
        });
      },
      duck: function (g, p, A) {    // waddle rock + turn
        g.rotation.z = Math.sin(p * PI * 4) * 0.14 * A * (1 - p);
        g.rotation.y = g.userData.baseRotY + Math.sin(p * PI * 2) * 0.5 * A;
        g.position.y = Math.abs(Math.sin(p * PI * 4)) * 0.06 * A;
      }
    };
    Object.assign(POSE, POSE_EXTRA);
    function restPose(type) {
      var g = M[type]; reset(g);
      var u = g.userData;
      if (u.rest) u.rest();
      if (u.tiers) { u.body.rotation.z = 0; u.tiers.forEach(function (t) { t.m.scale.set(1, 1, 1); t.m.position.y = t.y; }); u.star.position.y = 1.62; u.star.rotation.z = 0; }
      if (u.ends) { u.ends[0].rotation.x = 0; u.ends[1].rotation.x = 0; u.ball.scale.set(1, 1, 1); }
      if (u.glass) { u.glass.scale.set(1, 1, 1); u.glitter.rotation.x = 0; }
      if (u.hat) u.hat.rotation.z = 0.18;
      if (u.head) u.head.rotation.z = 0;
      if (u.wheels) u.wheels.forEach(function (w) { w.rotation.y = 0; });
      if (u.cap) { u.cap.scale.set(1, 1, 1); u.under.scale.set(1, 1, 1); u.cap.position.y = -0.36; u.under.position.y = -0.36; u.stem.scale.set(1, 1, 1); u.stem.position.y = -0.62; }
      if (u.layers) u.layers.forEach(function (l) { l.m.position.y = l.y; l.m.scale.set(1, 1, 1); });
    }

    // ---------------- cell state ----------------
    var DUR = Object.assign({ tree: 1.6, candy: 1.7, globe: 2.4, character: 1.3, reindeer: 1.4, van: 1.8, mushroom: 1.4, ufo: 2.2, burger: 1.5, duck: 1.6 }, DUR_EXTRA);
    var state = cells.map(function (c, i) { return { type: M[c.getAttribute('data-toy')] ? c.getAttribute('data-toy') : Object.keys(M)[0], anim: null, hover: 0, hoverT: 0, dirty: true, phase: (i * 0.37) % 1 }; });
    var motion = cal.getAttribute('data-motion') === 'lively' ? 1.25 : 1;
    var maxActive = parseInt(cal.getAttribute('data-max-active'), 10) || 3;

    function play(i) {
      var s = state[i];
      if (still()) { s.dirty = true; kick(); return; }              // reduced motion: highlight only
      if (s.anim && s.anim.big && s.anim.t < 0.6) return;           // ignore rapid re-taps mid-animation
      s.anim = { t: 0, big: true, A: 2.2 }; kick();
    }
    function hover(i, on) { state[i].hoverT = on && !still() ? 1 : 0; kick(); }

    var nextAmbient = 0, running = false, raf = 0, visible = true, last = 0;
    function activeCount() { return state.filter(function (s) { return s.anim; }).length; }
    function scheduleAmbient(now) {
      if (still() || now < nextAmbient || activeCount() >= maxActive) return;
      var idle = state.map(function (s, i) { return s.anim || !cells[i].classList.contains('is-open') ? -1 : i; }).filter(function (i) { return i >= 0; });
      if (!idle.length) return;
      var i = idle[Math.floor(Math.random() * idle.length)];
      state[i].anim = { t: 0, big: false, A: 0.9 * motion };
      nextAmbient = now + (900 + Math.random() * 1400) / motion;   // staggered starts with quiet pauses
    }

    var W = 0, H = 0, gridRect = null;
    function measure() {
      W = grid.clientWidth; H = grid.clientHeight;
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, mobile ? 2 : 2.5));   // sharp on retina, capped for speed
      renderer.setSize(W, H, false);
      canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
      gridRect = grid.getBoundingClientRect();
      state.forEach(function (s) { s.dirty = true; });
    }
    function drawCell(i, dt) {
      var c = cells[i], s = state[i];
      var closed = !c.classList.contains('is-open');
      var x = c.offsetLeft - grid.clientLeft, y = c.offsetTop - grid.clientTop, w = c.offsetWidth, h = c.offsetHeight;
      var inset = Math.max(3, w * 0.04);          // stay inside the rounded interior
      x += inset; y += inset; w -= inset * 2; h -= inset * 2;
      if (w <= 0 || h <= 0) return;
      renderer.setViewport(x, H - y - h, w, h); renderer.setScissor(x, H - y - h, w, h);
      renderer.setClearColor(0x000000, 0); renderer.clear();
      if (closed) return;
      cam.aspect = w / h; cam.updateProjectionMatrix();
      Object.keys(M).forEach(function (k) { M[k].visible = false; });
      var g = M[s.type]; g.visible = true; restPose(s.type);
      var fx = null, p = s.anim ? clamp(s.anim.t, 0, 1) : 0;
      if (s.anim) fx = POSE[s.type](g, p, s.anim.A, dt || 0.016);
      // hover: gentle lift + tilt
      s.hover += (s.hoverT - s.hover) * 0.25;
      g.position.y += s.hover * 0.12; g.rotation.x += s.hover * -0.12;
      shadow.scale.setScalar(1 - Math.min(0.4, Math.max(0, g.position.y - (g.userData.baseY || 0)) * 0.8));
      shadow.material.opacity = 0.9 - Math.min(0.5, Math.max(0, g.position.y) * 0.9);
      // sparkles
      if (fx && fx.sparkle) {
        sparks.visible = true; spMat.opacity = Math.sin(clamp((p - 0.35) / 0.65, 0, 1) * PI) * fx.sparkle;
        spSeed.forEach(function (sd, k) { var a = sd[0] + p * 3, rr = sd[1] * (0.5 + p * 0.6); spPos[k * 3] = Math.cos(a) * rr * 0.9; spPos[k * 3 + 1] = fx.sparkleY + Math.sin(a) * rr * 0.6 + sd[2] * 0.3; spPos[k * 3 + 2] = 0.3; });
        spGeo.attributes.position.needsUpdate = true;
      } else sparks.visible = false;
      renderer.render(scene, cam);
    }

    function frame(now) {
      var dt = Math.min(0.05, (now - (last || now)) / 1000); last = now;
      scheduleAmbient(now);
      var busy = false;
      state.forEach(function (s, i) {
        if (s.anim) {
          s.anim.t += dt / (DUR[s.type] * (s.anim.big ? 1.15 : 1));
          if (s.anim.t >= 1) { s.anim = null; s.dirty = true; }
          else { s.dirty = true; busy = true; }
        }
        if (Math.abs(s.hoverT - s.hover) > 0.01) { s.dirty = true; busy = true; }
        if (s.dirty) { drawCell(i, dt); s.dirty = false; }
      });
      if (running && (busy || !still())) raf = requestAnimationFrame(frame); else running = false;
    }
    function kick() { if (!running && visible && !document.hidden) { running = true; last = 0; raf = requestAnimationFrame(frame); } }
    function stop() { running = false; cancelAnimationFrame(raf); }

    measure();
    if ('ResizeObserver' in window) new ResizeObserver(function () { measure(); kick(); }).observe(grid);
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) { state.forEach(function (s) { s.dirty = true; }); kick(); } else stop(); }).observe(cal);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else kick(); });
    document.addEventListener('bb:motion', function () { state.forEach(function (s) { s.anim = null; s.dirty = true; }); kick(); });
    document.addEventListener('shopify:section:unload', function (e) { if (e.target.contains(cal)) { stop(); try { renderer.dispose(); renderer.forceContextLoss(); } catch (x) {} } });
    var media = cal.closest('.bb-pop-in');
    if (media) media.addEventListener('transitionend', function () { state.forEach(function (s) { s.dirty = true; }); kick(); });
    cal.classList.add('is-3d');
    kick();

    function redraw(i) { state[i].dirty = true; kick(); }
    function revealOpened() { cells.forEach(function (c, i) { if (c.classList.contains('is-open')) { state[i].dirty = true; if (c.classList.contains('is-pending')) { c.classList.remove('is-pending'); play(i); } } }); kick(); }
    var api = { play: play, hover: hover, redraw: redraw, revealOpened: revealOpened };
    if (/[?&]bbtest/.test(location.search)) {
      window.__bbCal = { info: function () { return { running: running, visible: visible, dirty: state.filter(function (s) { return s.dirty; }).length, open: cells.filter(function (c) { return c.classList.contains('is-open'); }).length, W: W, H: H }; },
        play: play, state: function () { return state.map(function (s) { return s.anim ? +s.anim.t.toFixed(2) : null; }); },
        active: activeCount,
        // reads pixels in the gaps BETWEEN compartments: must stay fully transparent (clipping check)
        gapAlpha: function () { gridRect = grid.getBoundingClientRect();
          var gl = renderer.getContext(), dpr = renderer.getPixelRatio(), max = 0, n = 0;
          var rects = cells.map(function (c) { return c.getBoundingClientRect(); });
          function inside(px, py) { return rects.some(function (r) { return px >= r.left && px <= r.right && py >= r.top && py <= r.bottom; }); }
          var buf = new Uint8Array(4);
          for (var yy = gridRect.top + 2; yy < gridRect.bottom - 2; yy += 3) for (var xx = gridRect.left + 2; xx < gridRect.right - 2; xx += 3) {
            if (inside(xx, yy)) continue;
            gl.readPixels(Math.round((xx - gridRect.left) * dpr), Math.round((H - (yy - gridRect.top)) * dpr), 1, 1, gl.RGBA, gl.UNSIGNED_BYTE, buf);
            max = Math.max(max, buf[3]); n++;
          }
          return { samples: n, maxAlpha: max };
        }
      };
    }
    return api;
  }

  function init() { document.querySelectorAll('[data-bb-cal]').forEach(boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
